import { N as f } from "../chunks/NcActions-5K-qjttC.mjs";
export {
  f as default
};
